module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "topbanner"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h5', {
    staticClass: "header center teal-text text-lighten hide-on-small-only"
  }, [_c('p', {
    staticClass: "center sdc-title"
  }, [_vm._v(" Node Back-end Developer")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+5511981671595"
    }
  }, [_vm._v(_vm._s(_vm.telefone))]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('h5', {
    staticClass: "header center teal-text text-lighten hide-on-med-and-up"
  }, [_vm._m(3), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+5511981671595"
    }
  }, [_vm._v(_vm._s(_vm.telefone))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h5', {
    staticClass: "header center teal-text text-lighten "
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.anglevisible),
      expression: "anglevisible"
    }]
  }, [_c('a', {
    staticClass: "scrollSoft"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parallax-container",
    attrs: {
      "id": "index-banner"
    }
  }, [_c('div', {
    staticClass: "section no-pad-bot no-pad-margin"
  }, [_c('div', {
    staticClass: "container no-pad-margin"
  }, [_c('div', {
    staticClass: "row center top-banner"
  }, [_c('h1', {
    staticClass: "header col s12 light-image center hide-on-small-only top-banner"
  }, [_vm._v(" \n                • NodeJS • NestJS  "), _c('br'), _vm._v(" \n                • JavaScript • TypeScript "), _c('br'), _vm._v(" • SQL  • NoSQL\n              ")]), _vm._v(" "), _c('h4', {
    staticClass: "header col s12 light-image center hide-on-med-and-up"
  }, [_vm._v(" Back-end Developer ")]), _vm._v(" "), _c('h4', {
    staticClass: "header col s12 light-image center hide-on-med-and-up"
  }, [_vm._v(" • NodeJS • NestJS")])]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "parallax",
    attrs: {
      "id": "slogan"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../.././static/img/topo.jpg"),
      "alt": "Software Developer"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://wa.me/5511981671595"
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "mailto:juscilan@gmail.com"
    }
  }, [_vm._v("juscilan@gmail.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://wa.me/5511981671595"
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4357672"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jm-b-top-banner.vue
// module id = 422
// module chunks = 1